/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { Grid, MenuItem, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { toast } from 'react-toastify';
import { Formik } from 'formik';
import { updateUserInfo } from '../../../utils/validators';
import { AddSystemUserProps } from './addSystemUserProps';
import Strings from '../../../i18n';
import { ErrorText } from '../../../components/auth/Profile/completeProfileStyles';
import { usePostUserInfoMutation } from '../../../services/users/usersService';
import {
  useAddUpdateSystemUserRoleMutation,
  useGetAppsMutation,
  useGetSystemRolesMutation
} from '../../../services/systemPermissions/systemPermissionsService';
import {
  CustomSelect,
  FormContainer
} from '../editUserAndRoleSideBar/editUserAndRoleSideBarStyles';
import { LabelSelect } from '../userSidebar/userSidebarStyles';
import { SideBarPhoneNumber } from '../../../components/commons/SideBarComponents/PhoneNumberWithLada/sideBarPhoneNumber';
import { SideBarEditablePropertyItem } from '../../../components/commons/SideBarComponents/EditablePropertyItem/sideBarEditablePropertyItem';
import {
  StyledContainerFooterSideBar,
  StyledContainerItems,
  StyledTitleSideBar
} from '../../../components/commons/SideBarComponents/sideBarComponentsStyles';
import { MultiSelectWithChipsAndSendButtonSideBar } from '../../../components/commons/SideBarComponents/MultiSelectWithChipsAndSendButton/multiSelectChipsSenSideBar';

interface FormValues {
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string | number | null;
  password: string;
}

export const AddNewSystemUser = ({
  reloadTable,
  setOpenSideBar
}: AddSystemUserProps) => {
  const [roleId, setRoleId] = useState(0);
  const handleChangeRole = (event: any) => {
    setRoleId(+event.target.value);
  };
  const [authorizedApps, setAuthorizedApps] = useState<
    {
      name: string;
      id: number;
    }[]
  >([]);
  const [getApps, { isSuccess: isSuccessGetApps, data: dataApps }] =
    useGetAppsMutation();

  const [
    getSystemRoles,
    { isSuccess: successGetSystemRoles, data: dataSystemRoles }
  ] = useGetSystemRolesMutation();

  const [
    postUserInfo,
    {
      isLoading: isLoadingPostInfo,
      isSuccess: isSucessPostInfo,
      data: dataPostInfo
    }
  ] = usePostUserInfoMutation();

  const [
    updateRoleByUserId,
    { isSuccess: isSuccessUpdateRole, isLoading: isLoadingUpdateRole }
  ] = useAddUpdateSystemUserRoleMutation();

  const updateUserRole = () => {
    if (dataPostInfo) {
      const payload = {
        userId: dataPostInfo?.id,
        systemRoleId: roleId
      };
      updateRoleByUserId(payload);
    }
  };
  const sendInfo = async (payload: any) => {
    postUserInfo(payload);
  };

  useEffect(() => {
    getSystemRoles('');
    getApps();
  }, []);
  useEffect(() => {
    if (isSucessPostInfo) {
      updateUserRole();
    }
  }, [isSucessPostInfo]);

  useEffect(() => {
    if (isSuccessUpdateRole && isSuccessUpdateRole) {
      toast.success(Strings.users.successCreateUser);
      reloadTable();
      setOpenSideBar(false);
    }
  }, [isSuccessUpdateRole, isSuccessUpdateRole]);

  return (
    <Formik
      enableReinitialize
      validationSchema={updateUserInfo}
      initialValues={{
        email: '',
        firstName: '',
        lastName: '',
        phoneNumber: null,
        password: '1234'
      }}
      onSubmit={(values: FormValues) => {
        let countryCode = '';
        let phoneNumber = '';
        const phoneStr = values.phoneNumber ? String(values.phoneNumber) : '';
        if (phoneStr) {
          countryCode = phoneStr.slice(0, -10);
          phoneNumber = phoneStr.substring(phoneStr.length - 10);
        }

        sendInfo({
          email: values.email,
          fullName: `${values.firstName} ${values.lastName}`,
          firstName: values.firstName,
          lastName: values.lastName,
          auth0Id: '',
          phoneNumber,
          countryCode,
          password: values.password,
          authorizedApps: authorizedApps.map((app) => app.id)
        });
      }}
    >
      {({
        handleChange,
        handleSubmit,
        values,
        isValid,
        setFieldTouched,
        errors,
        touched
      }) => (
        <>
          <StyledContainerItems>
            <StyledTitleSideBar>{Strings.users.addUser}</StyledTitleSideBar>
            <SideBarEditablePropertyItem
              item={{
                label: Strings.userProfile.firstNameLabel,
                type: 'inputText',
                currentValue: values.firstName,
                placeholder: Strings.userProfile.firstNameLabel,
                onChange: handleChange('firstName'),
                onBlur: () => setFieldTouched('firstName'),
                nameAndId: 'firstName'
              }}
            />
            {touched.firstName && errors.firstName && (
              <ErrorText>{errors.firstName}</ErrorText>
            )}
            <SideBarEditablePropertyItem
              item={{
                label: Strings.userProfile.lastNameLabel,
                type: 'inputText',
                currentValue: values.lastName,
                placeholder: Strings.userProfile.lastNameLabel,
                onChange: handleChange('lastName'),
                onBlur: () => setFieldTouched('lastName'),
                nameAndId: 'lastName'
              }}
            />
            {touched.lastName && errors.lastName && (
              <ErrorText>{errors.lastName}</ErrorText>
            )}
            <SideBarEditablePropertyItem
              item={{
                label: Strings.userProfile.emailLabel,
                type: 'inputText',
                currentValue: values.email,
                placeholder: Strings.userProfile.emailLabel,
                onChange: handleChange('email'),
                onBlur: () => setFieldTouched('email'),
                nameAndId: 'email'
              }}
            />
            {touched.email && errors.email && (
              <ErrorText>{errors.email}</ErrorText>
            )}
            {isSuccessGetApps && dataApps && (
              <MultiSelectWithChipsAndSendButtonSideBar
                label="Authorized Apps"
                selectedValues={authorizedApps}
                setSelectedValues={setAuthorizedApps}
                action={() => {}}
                options={dataApps ?? []}
                onChange={(e) => {
                  setAuthorizedApps(e);
                  console.log('e', e);
                }}
              />
            )}
            <SideBarPhoneNumber
              value={values.phoneNumber ?? ''}
              handleChange={(value) => handleChange('phoneNumber')(value ?? '')}
              id="phoneNumber"
              handleBlur={() => setFieldTouched('phoneNumber')}
            />

            {dataSystemRoles && (
              <FormContainer className="mt-3">
                <Grid item xs={12}>
                  <LabelSelect marginBottom={2}>System Role</LabelSelect>
                  <CustomSelect
                    onChange={handleChangeRole}
                    size="small"
                    fullWidth
                    value={roleId}
                  >
                    {successGetSystemRoles &&
                      dataSystemRoles &&
                      dataSystemRoles.map((element) => {
                        return (
                          <MenuItem value={element.id} key={element.id}>
                            {element.name}
                          </MenuItem>
                        );
                      })}
                    <MenuItem value={0} key={0}>
                      {Strings.common.assignLater}
                    </MenuItem>
                  </CustomSelect>
                </Grid>
              </FormContainer>
            )}
          </StyledContainerItems>
          <StyledContainerFooterSideBar>
            <button
              type="button"
              className="btn-cancel"
              onClick={() => {
                setOpenSideBar(false);
              }}
            >
              {Strings.common.cancel}
            </button>
            <LoadingButton
              color="info"
              onClick={() => {
                handleSubmit();
              }}
              variant="contained"
              size="small"
              loading={isLoadingPostInfo && isLoadingUpdateRole}
            >
              {Strings.users.addUser}
            </LoadingButton>
          </StyledContainerFooterSideBar>
        </>
      )}
    </Formik>
  );
};
